import { computed, defineComponent } from 'vue';
import LabelForm from './LabelForm.vue';
export default defineComponent({
    components: {
        LabelForm
    },
    props: {
        label: {
            type: String,
            required: true
        },
        modelValue: String,
        placeholder: String,
        description: String,
        disabled: Boolean,
        required: Boolean,
        autosize: Object
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const value = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        return { value };
    }
});
